import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as channelTransformer } from "./Channel";

export const ChannelMetaValidationSchema = Yup.object().shape({});

export const ChannelMetaObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    slug: "",
    label: "",
    description: null,
    type: null,
    channel_id: null,
    props: [],
    channel: null,
};

/**
 * Transform API object to a ChannelMeta object
 * @param {object} requestData JSON object from the API
 * @returns Object
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let channelMeta = Object.assign({}, ChannelMetaObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        slug: requestData.slug,
        label: requestData.label,
        description: requestData.description,
        type: requestData.type,
        channel_id: forceInt(requestData.channel_id),
        props: requestData.props,
        object_type: "channelMeta",
    });

    if (requestData.channel) {
        let channel = channelTransformer(requestData.channel);
        channelMeta = Object.assign({}, channelMeta, { channel: channel });
    }

    return channelMeta;
}

/**
 * Serialize the content object to a string
 * @param {object} item
 * @returns string
 */
export function serialize(item) {
    return JSON.stringify(item);
}

/**
 * Deserialize json string
 * @param {string} item
 * @returns object
 */
export function deserialize(item) {
    return JSON.parse(item);
}

/**
 *
 * @param {object} item The object being saved
 * @param {object} resetVars Values to overwrite after preparation
 * @returns Object
 */
export function prepare(item, resetVars = {}) {
    return Object.assign(
        {},
        item,
        {
            object_type: undefined,
        },
        resetVars
    );
}
